import Warehouses from './Warehouses'
import Others from './Others'
import React from 'react'

const Objects: React.FC = () => {
  return (
    <>
      <Warehouses />
      <Others />
    </>
  )
}

export default Objects